export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar endereço"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Digite o endereço"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione blockchain"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Realizar verificação"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risco baixo"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risco médio"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Risco alto"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Não está na lista negra"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verificar outro endereço"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Baixar PDF"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voltar"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione o provedor"])}
}